export default "__VITE_ASSET__BMfWUuif__"